<ng-container class="flexItemBiggest">
    <sortable-list [list]="orderedList"
                   [filteredList]="filteredList"
                   [itemId]="itemId"
                   [displayValue]="labeledValue"
                   (listOrderChanged)="onItemListChanged($event)">
    </sortable-list>
</ng-container>
